__turbopack_context__.v({
  "container": "mgR8qW_container",
  "impact": "mgR8qW_impact",
  "smartdistributionlabel": "mgR8qW_smartdistributionlabel",
  "wrapper": "mgR8qW_wrapper",
});
